import { ECreditDeductionCategory } from "@/utilities/types/AdCredit";
import { Button, Checkbox } from "rizzui";
import { cn } from "@/lib/utils";

interface CategoryFilterProps {
  selectedCategories: ECreditDeductionCategory[];
  onCategoryChange: (categories: ECreditDeductionCategory[]) => void;
}

const categoryOptions = [
  { value: ECreditDeductionCategory.GOOGLE_ADS, label: "Google Ads" },
  { value: ECreditDeductionCategory.LEAD, label: "Lead" },
  { value: ECreditDeductionCategory.FACEBOOK, label: "Facebook" },
  { value: ECreditDeductionCategory.MISCELLANEOUS, label: "Ancillary" },
];

export default function CategoryFilter({
  selectedCategories,
  onCategoryChange,
}: CategoryFilterProps) {
  const handleToggleCategory = (category: ECreditDeductionCategory) => {
    if (selectedCategories.includes(category)) {
      onCategoryChange(selectedCategories.filter((c) => c !== category));
    } else {
      onCategoryChange([...selectedCategories, category]);
    }
  };

  const handleSelectAll = () => {
    onCategoryChange(categoryOptions.map((opt) => opt.value));
  };

  const handleReset = () => {
    onCategoryChange([]);
  };

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex flex-wrap items-center gap-4">
        <span className="text-sm md:text-base font-medium text-gray-700">
          Filter by Category:
        </span>

        <div className="flex flex-wrap items-center gap-3">
          {categoryOptions.map((option) => (
            <label
              key={option.value}
              className={cn(
                "flex cursor-pointer items-center gap-2 rounded-md border px-3 py-1.5 text-sm transition-all",
                selectedCategories.includes(option.value)
                  ? "border-primary bg-primary/10 text-primary"
                  : "border-gray-200 hover:border-gray-300"
              )}
            >
              <Checkbox
                size="sm"
                checked={selectedCategories.includes(option.value)}
                onChange={() => handleToggleCategory(option.value)}
              />
              {option.label}
            </label>
          ))}
        </div>

        <div className="flex items-center gap-2 md:ml-auto md:justify-start">
          <Button size="sm" variant="outline" onClick={handleSelectAll}>
            Select All
          </Button>
          {selectedCategories.length > 0 && (
            <Button size="sm" onClick={handleReset} variant="outline">
              Reset
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
